module.exports = __webpack_public_path__ + "img/cpjs-img4.3071b34c.png";